import React, { useState, useEffect } from 'react'
import { useParams, useNavigate, Outlet } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Calendar, DatePicker } from 'antd'
import { Stack, Tooltip, Typography } from '@mui/material'
import { styled } from '@mui/material/styles'
import { tooltipClasses } from '@mui/material/Tooltip'
import dayjs from 'dayjs'

const HolidayToolTip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: '#FFC0CB',
    color: 'red',
    maxWidth: 220,
    fontSize: theme.typography.pxToRem(12),
    fontWeight: "bold",
    border: '1px red #dadde9',
  },
}))

const CalanderView = ({ formTemplateDetail, formList, holiday, handleChange }) => {
  const navigate = useNavigate()
  const { organization, project } = useParams()
  const { t } = useTranslation()

  const [selectDate, setSelectDate] = useState(dayjs())

  const base_target = `/portal/${organization}/${project}/permit_to_work/list/${formTemplateDetail["template_id"]}`

  useEffect(() => {
    handleChange(selectDate)
  }, [])

  const cellRender = (date, info) => {
    let calendar_year = date.get('year').toString()
    let calendar_month = (date.get('month') + 1).toString().padStart(2, "0")
    let calendar_date = date.get('date').toString().padStart(2, "0")
    let calendar_day = date.get('day')

    if ((selectDate.get('month') != date.get('month'))) {
      return (
        <div style={{ height: "150px", border: "1px dashed black" }}>
          <div style={{ display: "flex", flexDirection: "column", justifyContent: "end" }}>
            <div style={{ display: "flex", justifyContent: "end" }}>
              <Tooltip title="Delete">
                <div style={{ justifyContent: "center", alignItems: "center", height: "25px", width: "25px", display: "flex" }}>
                  <div>{date.get('date')}</div>
                </div>
              </Tooltip>
            </div>
          </div>
        </div>
      )
    }

    let holiday_detail = null

    if (calendar_day === 0) {
      holiday_detail = ""
    }

    if (holiday.hasOwnProperty(`${calendar_year}${calendar_month}`)) {
      let h = holiday[`${calendar_year}${calendar_month}`].filter((i) => i[0] == `${calendar_year}${calendar_month}${calendar_date}`)
      
      if (h.length > 0) {
        holiday_detail = h[0][1]
      }
    }

    return (
      <div style={{ height: "150px", display: "flex", flexDirection: "column", border: "1px dashed black" }}>
        <div style={{ display: "flex", flexDirection: "column", justifyContent: "end", marginTop: "2px", marginRight: "2px" }}>
          <div style={{ display: "flex", justifyContent: "end" }}>
            <HolidayToolTip title={holiday_detail}>
              <div style={holiday_detail != null ? { justifyContent: "center", alignItems: "center", height: "25px", width: "25px", backgroundColor: "red", color: "white", borderRadius: "50%", display: "flex" } : { justifyContent: "center", alignItems: "center", height: "25px", width: "25px", textAlign: "center" }}>
                <div>{date.get('date')}</div>
              </div>
            </HolidayToolTip>
          </div>
        </div>

        <div style={{ flex: 1, display: "flex", justifyContent: "start", margin: "2px", overflow: "auto" }}>
          <div style={{ width: "100%", textAlign: "start" }}>
            <Stack spacing={1}>
              {formList.filter((i) => i["date"] === `${calendar_year}-${calendar_month}-${calendar_date}`).map((i) => 
                <div style={{ paddingLeft: "5px", paddingRight: "5px",  border: "1px solid black", cursor: "pointer" }} onClick={() => navigate(`${base_target}/${i["form_id"]}`)}>
                  <div style={{ display: "flex", justifyContent: "space-between" }}>
                    <Typography sx={{ display: '-webkit-box', overflow: 'hidden', WebkitBoxOrient: 'vertical', WebkitLineClamp: 1 }} variant="body2">{i["form_id"]}</Typography>
                  </div>
                </div>
              )}
            </Stack>
          </div>
        </div>
      </div>
    )
  }

  const onPanelChange = (value, mode) => {
    setSelectDate(value)
  }

  return (<>
    <div>
      <Calendar
        fullCellRender={cellRender}
        onPanelChange={onPanelChange}
        headerRender={({ value, type, onChange, onTypeChange }) => {
          return (<>
            <div>
              <div style= {{ display: "flex", justifyContent: "center", marginBottom: "10px" }}>
                <Typography variant="h6" component="h2">
                  <u>{formTemplateDetail["template_name"]}</u>
                </Typography>
              </div>
              
              <div>{t("ptw_templateNo")}: {formTemplateDetail["template_no"]}</div>
              <div>{t("ptw_equipmentDescription")}: {formTemplateDetail["description"]}</div>
              <div>{t("ptw_effectiveDate")}: {formTemplateDetail["effective_date"]}</div>
            </div>

            <div style={{ display: "flex", justifyContent: "end", paddingBottom: "10px" }}>
              <DatePicker value={selectDate} onChange={(date, _) => { setSelectDate(date); onChange(date); handleChange(date); }} picker="month" />
            </div>
          </>)
        }}
      />
    </div>
  </>)
}

export default CalanderView
